import { render } from "./KanBan.vue?vue&type=template&id=ace056de&scoped=true"
import script from "./KanBan.vue?vue&type=script&lang=js"
export * from "./KanBan.vue?vue&type=script&lang=js"

import "./KanBan.vue?vue&type=style&index=0&id=ace056de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace056de"]])

export default __exports__